import type { User } from "@ferrivia/api-contract";
import { AuthGate, useLocaleSync } from "@ferrivia/auth-web";
import { NoAccess } from "./auth/NoAccess";
import { LoginScreen } from "./components/LoginScreen";
import { useMobileKeyboardScrollLock } from "./hooks/useMobileKeyboardScrollLock";
import { ClinicRoutes } from "./routes";

function AuthedApp({ user, signOut }: { user: User; signOut: () => void }) {
  useLocaleSync(user);

  return <ClinicRoutes user={user} onSignOut={signOut} />;
}

export function App() {
  useMobileKeyboardScrollLock();

  return (
    <AuthGate
      renderLogin={({ initialErrorCode, onSignedIn }) => (
        <LoginScreen initialErrorCode={initialErrorCode} onSignedIn={onSignedIn} />
      )}
      requireRole="staff"
      renderNoAccess={({ signOut }) => <NoAccess onSignOut={signOut} />}
    >
      {({ user, signOut }) => <AuthedApp user={user} signOut={signOut} />}
    </AuthGate>
  );
}
